import {boldlyLog} from "../Utility/logging";

const LOGGERS = {};

/**
 * Get a tagged logger from cache, or create it and store in cache.
 *
 * @param name
 * @param options
 * @returns {TaggedLogger}
 */
export function getTaggedLogger(name, options = {silent: false, styles: null}) {
  return (LOGGERS[name] ||= createTaggedLogger(name, options));
}

export function createTaggedLogger(name, options = {silent: false}) {
  if (name === null)
    options.silent = true;

  return new TaggedLogger(name, options);
}


/**
 * 2025-08 eliminate console clutter by adding tags to log messages, so we can filter on them,
 * and making a style that stands out.
 */
class TaggedLogger {
  constructor(name, {silent = false, styles }) {
    this.name = name;
    this.silent = silent;
    this.styles = styles || "font-weight: bold; color: teal;"
  }

  debug(message, ...args) {
    if (this.silent) return null;
    return console.debug("%c%s", this.getStyles(), this.addPrefix(message), ...args)
  }
  info(message, ...args) {
    if (this.silent) return null;
    return console.info("%c%s", this.getStyles(), this.addPrefix(message), ...args)
  }
  log(message, ...args) {
    if (this.silent) return null;
    return console.info("%c%s", this.getStyles(), this.addPrefix(message), ...args)
  }
  warn(message, ...args) {
    if (this.silent) return null;
    return console.warn("%c%s", this.getStyles(), this.addPrefix(message), ...args)
  }
  error(message, ...args) {
    if (this.silent) return null;

    return console.error("%c%s", this.getStyles(), this.addPrefix(message), ...args)
  }

  addPrefix(message) {
    return  `[${this.name}] ${message}`
  }

  getStyles() {
    return this.styles;
  }
}
